import React from 'react';
import { HStack, Text, useColorModeValue } from '@chakra-ui/react';
import { FaTrophy, FaHeart } from 'react-icons/fa';

const GameStats = ({ score, sessionLives }) => {
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const scoreColor = useColorModeValue('yellow.500', 'yellow.300');
  const sessionLivesColor = useColorModeValue('red.500', 'red.300');

  return (
    <HStack spacing={6} justify="center" py={4}>
      <HStack spacing={2}>
        <FaTrophy color={scoreColor} />
        <Text color={textColor} fontWeight="medium">
          Score: <Text as="span" color={scoreColor} fontWeight="bold">{score}</Text>
        </Text>
      </HStack>

      <HStack spacing={2}>
        <FaHeart color={sessionLivesColor} />
        <Text color={textColor} fontWeight="medium">
          Lives: <Text as="span" color={sessionLivesColor} fontWeight="bold">{sessionLives}</Text>
        </Text>
      </HStack>
    </HStack>
  );
};

export default GameStats; 